var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"project-data-page"}},[_c('PageTitle',{attrs:{"icon":"","title":_vm.title,"loading":_vm.loading}}),_c('FilterDataList',{attrs:{"id":_vm.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }